var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Shape from './Shape';
import * as lodash from '../utils/lodash';
import { inBBox } from '../utils/bbox';
import { measureText } from '../utils/measureText';
export var shapeKeys = [
    'x',
    'y',
    'text',
    'fontSize',
    'fontFamily',
    'truncate',
    'textAlign',
    'textBaseline',
    'fontWeight',
];
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'text';
        _this.svgTagName = 'text';
        _this.shapeKeys = shapeKeys;
        _this._isOverflow = false;
        return _this;
    }
    Object.defineProperty(Text.prototype, "_isEmpty", {
        get: function () {
            var text = this.attr.text;
            if (text === undefined || text === null || text === '') {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Text.prototype, "isMutiLine", {
        get: function () {
            var _a = this.attr, text = _a.text, truncate = _a.truncate;
            return !!((text + '').indexOf('\n') !== -1 || truncate);
        },
        enumerable: true,
        configurable: true
    });
    Text.prototype.getDefaultAttr = function () {
        return __assign(__assign({}, _super.prototype.getDefaultAttr.call(this)), { text: '', x: 0, y: 0 });
    };
    Text.prototype.isOverflow = function () {
        return this._isOverflow;
    };
    Text.prototype.getAnimationKeys = function () {
        return __spreadArrays(_super.prototype.getAnimationKeys.call(this), ['x', 'y', 'fontSize']);
    };
    Text.prototype.getSpanList = function () {
        var out = [];
        this.eachSpanList(function (text, x, y) { return out.push({ x: x, y: y, text: text }); });
        return out;
    };
    Text.prototype.eachSpanList = function (callback) {
        var _a = this.attr, x = _a.x, y = _a.y;
        var _b = this.getTextStyle(), fontSize = _b.fontSize, lineHeight = _b.lineHeight, textBaseline = _b.textBaseline;
        var textList = this._getInlineTextList();
        var gap = (lineHeight - fontSize) / 2;
        textList.forEach(function (rowText, rowIndex) {
            var rowY = y;
            if (textBaseline === 'top') {
                rowY = y + rowIndex * lineHeight + gap;
            }
            else if (textBaseline === 'middle') {
                rowY = y + (rowIndex + 0.5 - textList.length / 2) * lineHeight;
            }
            else if (textBaseline === 'bottom') {
                rowY = y - (textList.length - 1 - rowIndex) * lineHeight - gap;
            }
            callback(rowText, x, rowY);
        });
    };
    Text.prototype.brush = function (ctx) {
        var _this = this;
        var _text = this.attr.text;
        if (this._isEmpty) {
            return;
        }
        // ctx.save();
        // ctx.arc(this.attr.x, this.attr.y, 4, 0 , Math.PI * 2);
        // ctx.fillStyle = 'red';
        // ctx.fill();
        // ctx.restore();
        var text = _text + '';
        var _a = this, needFill = _a.needFill, needStroke = _a.needStroke;
        if (!this.isMutiLine) {
            if (needStroke && ctx.strokeText) {
                if (this.attr.maxWidth > 0) {
                    ctx.strokeText(text, this.attr.x, this.attr.y, this.attr.maxWidth);
                }
                else {
                    ctx.strokeText(text, this.attr.x, this.attr.y);
                }
            }
            if (needFill) {
                if (this.attr.maxWidth > 0) {
                    ctx.fillText(text, this.attr.x, this.attr.y, this.attr.maxWidth);
                }
                else {
                    ctx.fillText(text, this.attr.x, this.attr.y);
                }
            }
            return;
        }
        this.eachSpanList(function (rowText, x, y) {
            if (needStroke && ctx.strokeText) {
                if (_this.attr.maxWidth > 0) {
                    ctx.strokeText(rowText, x, y, _this.attr.maxWidth);
                }
                else {
                    ctx.strokeText(rowText, x, y);
                }
            }
            if (needFill) {
                if (_this.attr.maxWidth > 0) {
                    ctx.fillText(rowText, x, y, _this.attr.maxWidth);
                }
                else {
                    ctx.fillText(rowText, x, y);
                }
            }
        });
    };
    Text.prototype.measureText = function () {
        var textStyle = this.getTextStyle();
        var text = this._isEmpty ? '' : this.attr.text + '';
        return measureText(text, textStyle);
    };
    Text.prototype.getTextStyle = function () {
        var fontSize = this.getExtendAttr('fontSize');
        return {
            fontSize: fontSize,
            fontFamily: this.getExtendAttr('fontFamily'),
            fontWeight: this.getExtendAttr('fontWeight'),
            textAlign: this.getExtendAttr('textAlign'),
            textBaseline: this.getExtendAttr('textBaseline'),
            lineHeight: this.attr.lineHeight || fontSize,
        };
    };
    Text.prototype.computeBBox = function () {
        if (this._isEmpty) {
            return { x: 0, y: 0, width: 0, height: 0 };
        }
        var _a = this.attr, x = _a.x, y = _a.y;
        var textStyle = this.getTextStyle();
        var fontSize = textStyle.fontSize, textAlign = textStyle.textAlign, textBaseline = textStyle.textBaseline, lineHeight = textStyle.lineHeight;
        var textWidth;
        var textHeight;
        if (!this.isMutiLine) {
            textWidth = measureText(this.attr.text + '', textStyle).width;
            textHeight = fontSize;
        }
        else {
            var inlineTextList = this._getInlineTextList();
            textHeight = inlineTextList.length * lineHeight;
            textWidth = lodash.max(inlineTextList.map(function (text) { return measureText(text, textStyle).width; })) || 0;
        }
        if (this.attr.maxWidth > 0) {
            textWidth = Math.min(textWidth, this.attr.maxWidth);
        }
        var bbox = {
            x: x,
            y: y,
            width: textWidth,
            height: textHeight,
        };
        if (textAlign === 'center') {
            bbox.x = x - textWidth / 2;
        }
        else if (textAlign === 'right') {
            bbox.x = x - textWidth;
        }
        if (textBaseline === 'top') {
            bbox.y = y;
        }
        else if (textBaseline === 'middle') {
            bbox.y = y - textHeight / 2;
        }
        else {
            bbox.y = y - textHeight;
        }
        return bbox;
    };
    Text.prototype.isPointOnPath = function (x, y) {
        return inBBox(this.getBBox(), x, y);
    };
    Text.prototype.onEvent = function (type) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        _super.prototype.onEvent.apply(this, __spreadArrays([type], params));
        if (this._isOverflow && this.ownerRender.isBrowser()) {
            if (type === 'mouseenter') {
                this.ownerRender.getDom().title = this.attr.text + '';
            }
            if (type === 'mouseleave') {
                this.ownerRender.getDom().removeAttribute('title');
            }
        }
    };
    Text.prototype.getSvgAttributes = function (figma) {
        var anchor;
        var dy = 0;
        var textStyle = this.getTextStyle();
        if (textStyle.textBaseline === 'bottom') {
            dy = -textStyle.fontSize / 2 + textStyle.fontSize / 10;
        }
        else if (textStyle.textBaseline === 'top') {
            dy = textStyle.fontSize / 2 + textStyle.fontSize / 10;
        }
        else if (textStyle.textBaseline === 'middle') {
            dy = +textStyle.fontSize / 10 + (figma ? textStyle.fontSize / 5 + 1 : 0);
        }
        if (textStyle.textAlign === 'start' || textStyle.textAlign === 'left') {
            anchor = 'start';
        }
        if (textStyle.textAlign === 'right' || textStyle.textAlign === 'end') {
            anchor = 'end';
        }
        if (textStyle.textAlign === 'center') {
            anchor = 'middle';
        }
        var ret = __assign(__assign({}, _super.prototype.getSvgAttributes.call(this)), { x: this.attr.x, y: this.attr.y, dy: dy, 'dominant-baseline': 'middle', 'text-anchor': anchor, 'paint-order': 'stroke' });
        if (this.attr.maxWidth > 0) {
            ret.textLength = this.attr.maxWidth;
        }
        return ret;
    };
    Text.prototype._getInlineTextList = function () {
        this._isOverflow = false;
        var _a = this.attr, _text = _a.text, truncate = _a.truncate;
        var textStyle = this.getTextStyle();
        var lineHeight = textStyle.lineHeight;
        if (this._isEmpty) {
            return [];
        }
        var text = _text + '';
        if (!truncate) {
            return text.split('\n');
        }
        var textList = text.split('');
        var rowTextList = [];
        var outerWidth = truncate.outerWidth, outerHeight = truncate.outerHeight, _b = truncate.ellipsis, ellipsis = _b === void 0 ? '...' : _b;
        var ellipseWidth = measureText(ellipsis, textStyle).width;
        if (lodash.isNumber(outerHeight) && outerHeight < lineHeight) {
            return [];
        }
        var rowWidth = 0;
        var rowHeight = lineHeight;
        var rowIndex = 0;
        var rowLetterWidthList = [];
        rowTextList.push('');
        for (var i = 0; i < textList.length; i++) {
            var letter = textList[i];
            if (letter === '\r') {
                continue;
            }
            if (letter === '\n') {
                rowTextList.push('');
                rowIndex++;
                rowWidth = 0;
                rowHeight += lineHeight;
                rowLetterWidthList.length = 0;
                continue;
            }
            var letterWidth = measureText(letter, textStyle).width;
            if (outerWidth && letterWidth + rowWidth <= outerWidth) {
                rowWidth += letterWidth;
                rowLetterWidthList.push(letterWidth);
                rowTextList[rowIndex] += letter;
            }
            else if (outerHeight && rowHeight + lineHeight > outerHeight) {
                var tempWidth = 0;
                var tempStr = '';
                for (var j = 0; j < rowLetterWidthList.length; j++) {
                    if (tempWidth + rowLetterWidthList[j] <= outerWidth - ellipseWidth) {
                        tempStr += rowTextList[rowIndex][j];
                        tempWidth += rowLetterWidthList[j];
                    }
                    else {
                        break;
                    }
                }
                rowTextList[rowIndex] = tempStr + ellipsis;
                this._isOverflow = true;
                break;
            }
            else {
                rowTextList.push(letter);
                rowIndex++;
                rowWidth = letterWidth;
                rowHeight += lineHeight;
                rowLetterWidthList.length = 0;
                rowLetterWidthList.push(letterWidth);
            }
        }
        return rowTextList;
    };
    return Text;
}(Shape));
export default Text;
